$(function() {

    const editBuildItem = $('#edit-build-item');

    let editBuildItemModal = null;

    if (editBuildItem.length) {

        editBuildItemModal = new bootstrap.Modal($('#edit-build-item'));

        $(document).on('click', '.edit-build-item-toggle', function(e) {
            editBuildItemModal.toggle(this);
        });

    }

    $('#add-build-item').on('submit', function(e) {
        e.preventDefault();

        const $this = $(this);
        const $form = $this.closest('form');
        const $mill = $('#tbl_items_c_item_mill_id');
        const $siding_patterns = $('#tbl_items_c_item_pattern_type');
        const $bl_grades = $('#tbl_items_c_item_bl_grade');
        const $surface = $('#tbl_items_c_item_surface');
        const $drying_method = $('#tbl_items_c_item_seasoning_id');
        const $uses = $('#tbl_items_c_item_use_id');
        const $species = $('#tbl_items_c_item_species_id');
        const $sqft = $('#tbl_project_items_c_square_footage');
        const $lft = $('#tbl_project_items_c_linear_footage');

        const serializedInputs = $form.serialize();

        $mill.removeClass('is-invalid');
        $siding_patterns.removeClass('is-invalid');
        $bl_grades.removeClass('is-invalid');
        $surface.removeClass('is-invalid');
        $drying_method.removeClass('is-invalid');
        $uses.removeClass('is-invalid');
        $species.removeClass('is-invalid');
        $sqft.removeClass('is-invalid');
        $lft.removeClass('is-invalid');

        axios.post($form.attr('action'), serializedInputs)
            .then(function (response) {

                let html = "";

                if (response.data.success) {
                    if (response.data.results.length) {

                        $('#filtered-sqft').val($form.find('#sqft').val());

                        response.data.results.forEach(build_item => {
                            html += `
                                <tr>
                                    <td>
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="items[]">
                                                <input class="form-check-input item-array-input" type="checkbox" name="items[]" value="${build_item.c_id}">
                                            </label>
                                        </div>
                                    </td>
                                    <td>${build_item.c_item_mill_id || ''}</td>
                                    <td>${build_item.c_item_nominal_thickness_fraction || ''}</td>
                                    <td>${build_item.c_item_nominal_width_fraction || ''}</td>
                                    <td>${build_item.c_item_species_id || ''}</td>
                                    <td>${build_item.c_item_bl_grade || ''}</td>
                                    <td>${build_item.c_item_mill_grade || ''}</td>
                                    <td>${build_item.c_item_pattern_type || ''}</td>
                                    <td>${build_item.c_item_finisher_id || ''}</td>
                                    <td>${build_item.c_item_surface || ''}</td>
                                </tr>
                            `;
                        });
                    } else {
                        html = `<tr>
                            <td  colspan="10">
                                <h5 class="text-center">No build items found</h5>
                            </td>
                        </tr>`;
                    }
                } else {

                    html = `<tr>
                        <td  colspan="18">
                            <h5 class="text-center">No items found</h5>
                        </td>
                    </tr>`;

                    Object.getOwnPropertyNames(response.data.errors).forEach(error => {
                        $(`*[name="${error}"]`).addClass('is-invalid');
                    });
                }

                $('#item-builder-preview').html(html);

            })
            .catch(function (error) {
                console.log({error});
            });
    });

    $('#tbl_project_items_c_square_footage').on('input', function() {
        $('#tbl_project_items_c_linear_footage').val('');
    })
    $('#tbl_project_items_c_linear_footage').on('input', function() {
        $('#tbl_project_items_c_square_footage').val('');
    })

    $('#add-to-builder').on('submit', function(e) {
        e.preventDefault();

        const $this = $(this);
        const $form = $this.closest('form');
        const $sqft = $('#tbl_project_items_c_square_footage');
        const $lft  = $('#tbl_project_items_c_linear_footage');
        const $size = $('button[name="tbl_item_c_item_size"]');
        const $itemBuilderPreview = $('#item-builder-preview');
        let html = '';

        let serializedInputs = $form.serialize() + `&${this.name}=${$this.val()}`;

        if ($sqft.val()) {
            $lft.val('');
            serializedInputs += `&tbl_project_items_c_square_footage=${$sqft.val()}`;
        } else {
            serializedInputs += `&tbl_project_items_c_linear_footage=${$lft.val()}`;
        }

        $sqft.removeClass('is-invalid');
        $lft.removeClass('is-invalid');
        $size.removeClass('border border-danger');
        $itemBuilderPreview.removeClass('bg-danger bg-opacity-10');

        axios.post($form.attr('action'), serializedInputs)
            .then(function (response) {

                if (response.data.success) {
                    $('#add-to-builder-form-errors').removeClass('alert-danger');
                    $('#add-to-builder-form-errors').addClass('alert-success');
                    $('#add-to-builder-form-errors').removeClass('d-none');
                    $('#add-to-builder-form-errors').addClass('d-block');
                    $('#add-to-builder-form-errors').html(response.data.results.length > 1 ? 'Items added to builder!' : 'Item added to builder!');

                    if (response.data.results.length) {

                        response.data.results.forEach(buildItem => {
                            html += addItemToEditItemsTable(buildItem, true);
                        });

                        $('#item-builder').append(html);

                        toastr.success(response.data.results.length > 1 ? 'Items added to builder!' : 'Item added to builder!');

                    } else {

                        html = `<tr>
                            <td  colspan="19">
                                <h5 class="text-center">No items found</h5>
                            </td>
                        </tr>`;

                        $itemBuilderPreview.html(html);
                    }

                } else {
                    const errorsArray = Object.getOwnPropertyNames(response.data.errors);
                    const reversedErrorsArray = errorsArray.slice().reverse();

                    let html = '';
                    errorsArray.forEach(error => {
                        html += `<li>${response.data.errors[error]}</li>`;
                        if (error == 'items') {
                            $itemBuilderPreview.addClass('bg-danger bg-opacity-10');
                        } else {
                            $(`input[name="${error}"]`).addClass('is-invalid');
                        }
                    });

                    $('#add-to-builder-form-errors').html(`<ul class="mb-0">${html}</ul>`);
                    $('#add-to-builder-form-errors').removeClass('alert-success');
                    $('#add-to-builder-form-errors').addClass('alert-danger');
                    $('#add-to-builder-form-errors').removeClass('d-none');

                    if (errorsArray.length) {
                        setTimeout(function() {
                            window.scrollTo({
                                top: $(errorsArray[0] == 'items' ? '#item-builder-preview' : `input[name="${errorsArray[0]}"]`).offset().top - 45,
                                left: 0,
                                behavior: "smooth"
                            });
                        }, 1500);
                    }

                    reversedErrorsArray.reverse().forEach(error => {
                        toastr.error(response.data.errors[error]);
                    });
                }
            })
            .catch(function (error) {
                console.log({error});
            });
    });

    $(document).on('submit', '.clone-build-item', function(e) {
        e.preventDefault();

        const $this = $(this);
        const $form = $this.closest('form');

        axios.post($form.attr('action'), $form.serialize())
            .then(function (response) {

                const build_item = response.data.results;

                let html = `
                    <tr class="item-builder-row-${build_item.c_id}">
                        <td>
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" name="remove[]" value="${build_item.c_id}">
                            </div>
                        </td>
                        <td>
                            <div class="row justify-content-center">
                                <form id="clone-build-item" class="clone-build-item d-inline w-auto p-0 ps-1 p-e1" method="POST" action="${build_item.action_clone}">
                                    <input type="hidden" name="_method" value="POST">
                                    <button type="submit" class="btn btn-link p-0" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Clone" data-bs-original-title="Clone">
                                        <svg class="" height="20px" width="20px" fill="#0d6efd">
                                            <use xlink:href="#content-copy" height="20px" width="20px"></use>
                                        </svg>
                                    </button>
                                </form>

                                <form class="delete-build-item d-inline w-auto p-0 ps-1 p-e1" method="POST" action="${build_item.action_delete}">
                                    <input type="hidden" name="_method" value="DELETE">
                                        <button type="submit" class="btn btn-link p-0" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                            <svg class="" height="20px" width="20px" fill="#DC3545">
                                                <use xlink:href="#delete" height="20px" width="20px"></use>
                                            </svg>
                                    </button>
                                </form>
                            </div>
                        </td>
                        <td>
                            <a href="#edit-build-item" class="edit-build-item-toggle text-primary" data-project_id="${build_item.c_project_id}" data-project_item_id="${build_item.c_id}">View</a>
                        </td>
                        <td>${build_item.c_square_footage || ''}</td>
                        <td>${build_item.c_linear_footage || ''}</td>
                        <td>${build_item.item.c_item_nominal_thickness_fraction || ''}</td>
                        <td>${build_item.item.c_item_nominal_width_fraction || ''}</td>
                        <td>${build_item.item.c_item_actual_thickness_fraction || ''}</td>
                        <td>${build_item.item.c_item_actual_width_fraction || ''}</td>
                        <td>${build_item.item.c_item_exposed_face_fraction || ''}</td>
                        <td>${build_item.item.c_item_species_id || ''}</td>
                        <td>${build_item.item.c_item_bl_grade || ''}</td>
                        <td>${build_item.item.c_item_pattern_type || ''}</td>
                        <td>${build_item.item.c_item_surface || ''}</td>
                        <td>${build_item.item.c_item_finish || ''}</td>
                        <td>${build_item.item.c_item_mill_id || ''}</td>
                        <td>${build_item.item.c_item_finisher_id || ''}</td>
                    </tr>
                `;

                $('#item-builder').append(html);
                toastr.success('Item cloned!');
            })
            .catch(function (error) {
                console.log({error});
            });
    });

    $(document).on('submit', '.delete-build-item', function(e) {
        e.preventDefault();

        const $this = $(this);
        const $form = $this.closest('form');

        axios.post($form.attr('action'), $form.serialize())
            .then(function (response) {
                $this.closest('tr').find('.delete-build-item button[type="submit"]').tooltip('hide');
                $this.closest('tr').remove();
                toastr.success('Item removed!');
            })
            .catch(function (error) {
                console.log({error});
            });
    });

    $('.bl-custom-size-holder input').on('focusin', function(e) {
        $(this)
            .closest('.bl-custom-size-holder')
            .find('.bl-custom-size-dropdown')
            .addClass('bl-custom-size-dropdown__show');
    });

    $('.bl-custom-size-holder input').on('focusout', function(e) {
        if ($(e.relatedTarget).hasClass('bl-custom-size-buttons')) {
            return;
        }

        $(this)
            .closest('.bl-custom-size-holder')
            .find('.bl-custom-size-dropdown')
            .removeClass('bl-custom-size-dropdown__show');
    });

    $('.bl-custom-size-buttons').on('focusout', function(e) {
        if ($(e.relatedTarget).hasClass('bl-custom-size-buttons')) {
            return;
        }

        $(this)
            .closest('.bl-custom-size-holder')
            .find('.bl-custom-size-dropdown')
            .removeClass('bl-custom-size-dropdown__show');
    });

    $('.bl-custom-size-dropdown button').on('click', function(e) {
        const blCustomSizeHolder = $(this).closest('.bl-custom-size-holder');

        blCustomSizeHolder
            .find('input')
            .val($(this).data('size'));

        blCustomSizeHolder
            .find('.bl-custom-size-dropdown')
            .removeClass('bl-custom-size-dropdown__show');
    });

    $('#edit-build-item').on('show.bs.modal', function(e) {
        const trigger = $(e.relatedTarget);
        const projectId = trigger.data('project_id');
        const projectItemId = trigger.data('project_item_id');

        axios
            .get(`/projects/${projectId}/project-items/${projectItemId}`)
            .then(function (response) {

                // handle success
                console.log({response});

                // Get preview image element
                $('#display-c_pattern_image_path').hide();

                // Top Section
                $('#display-c_item_mill_id').html(response.data.item.c_item_mill_id);
                $('#edit-c_item_name').html(response.data.item.c_item_concat_name);

                // Top row of inputs
                $('#edit-c_square_footage').val(response.data.c_square_footage);
                $('#edit-c_cost_per_mbft').val(response.data.c_cost_per_mbft);
                $('#display-c_item_total_quoted').val(response.data.c_item_total_quoted);

                // TODO: Pre fill Price Quoted/Sqft from database once it's added
                $('#edit-c_item_mill_id').val(response.data.item.c_item_mill_id);

                $('#hidden-c_id').val(response.data.c_id);
                $('#hidden-c_project_id').val(response.data.c_project_id);
                $('#hidden-c_item_id').val(response.data.c_item_id);
                $('#hidden-c_item_exposed_face').val(response.data.item.c_item_exposed_face_fraction);
                $('#hidden-c_item_nominal_thickness').val(response.data.item.c_item_nominal_thickness_fraction);
                $('#hidden-c_item_nominal_width').val(response.data.item.c_item_nominal_width_fraction);
                $('#hidden-c_item_actual_width').val(response.data.item.c_item_actual_width);

                $('#default-c_square_footage').val(response.data.c_square_footage);
                $('#default-c_linear_footage').val(response.data.c_linear_footage);
                $('#default-c_board_footage').val(response.data.c_board_footage);
                $('#default-c_item_total_quoted').val(response.data.c_item_total_quoted);

                $('#edit-c_square_footage').val(response.data.c_square_footage);
                $('#edit-c_linear_footage').val(response.data.c_linear_footage);
                $('#edit-c_board_footage').val(response.data.c_board_footage);

                // Left Box
                $('#edit-c_item_project_name').val(response.data.c_item_project_name);
                $('#edit-c_item_mill_setup_fee').val(response.data.c_item_mill_setup_fee);
                $('#edit-c_item_finisher_setup_fee').val(response.data.c_item_finisher_setup_fee);
                $('#edit-c_item_density').val(response.data.item.c_item_density);
                $('#edit-c_items_weight').val(response.data.c_items_weight);
                $('#edit-c_item_customer_notes').val(response.data.c_item_customer_notes);
                $('#edit-c_item_mill_notes').val(response.data.c_item_mill_notes);

                // Right Box
                $('#edit-c_item_bl_grade').val(response.data.item.c_item_bl_grade);
                $('#edit-c_item_finisher_id').val(response.data.item.c_item_finisher_id);
                $('#edit-c_item_finish').val(response.data.item.c_item_finish);
                $('#edit-c_item_actual_thickness').val(response.data.item.c_item_actual_thickness_fraction);
                $('#edit-c_item_actual_width').val(response.data.item.c_item_actual_width_fraction);
                $('#edit-c_item_exposed_face').val(response.data.item.c_item_exposed_face_fraction);
                $('#edit-c_item_use_id').val(response.data.item.c_item_use_id);
                $('#edit-c_item_surface').val(response.data.item.c_item_surface);
                $('#edit-c_item_seasoning_id').val(response.data.item.c_item_seasoning_id);
                $('#edit-c_item_product_id').val(response.data.item.c_item_product_id);
                $('#edit-c_item_variance').val(response.data.item.c_item_variance);

                if (response.data.c_pattern_image) {
                    $('#display-c_pattern_image').attr('src', response.data.c_pattern_image);
                    $('#display-c_pattern_image').show();
                    $('#remove-custom-pattern-image').val(0);
                    $('#display-item-c_pattern_image_path').attr('src', response.data.item.pattern.c_pattern_image_path);
                    $('#display-item-c_pattern_image_path').hide();
                } else if (response.data.item.pattern.c_pattern_image_path) {
                    $('#remove-custom-pattern-image').val(0);
                    $('#display-item-c_pattern_image_path').attr('src', response.data.item.pattern.c_pattern_image_path);
                    $('#display-item-c_pattern_image_path').show();
                } else {
                    $('#display-c_pattern_image_path').hide();
                }

                $('#edit-c_item_tally_notes').val(response.data.c_item_tally_notes);
                $('#edit-c_tally_type').val(response.data.item.c_item_tally_type);

                $('#edit-c_item_pattern_type').val(response.data.item.c_item_pattern_type);
                $('#edit-c_item_mill_grade').val(response.data.item.c_item_mill_grade);


                $('#edit-c_item_nominal_thickness').val(response.data.item.c_item_nominal_thickness_fraction);
                $('#edit-c_item_nominal_width').val(response.data.item.c_item_nominal_width_fraction);
                $('#edit-c_item_species_id').val(response.data.item.c_item_species_id);
                $('#edit-c_item_mill_id').val(response.data.item.c_item_mill_id);
            })
            .catch(function (error) {
                // handle error
                console.log({error});
            })
    });

    $('#edit-build-item').on('hidden.bs.modal', function(e) {

        // Get preview image element
        $('#display-c_pattern_image_path').hide();

        // Top Section
        $('#display-c_item_mill_id').html('');
        $('#edit-c_item_name').html('');

        // Top row of inputs
        $('#edit-c_square_footage').val('');
        // TODO: Pre fill Price Quoted/Sqft from database once it's added
        $('#edit-c_item_mill_id').val('');

        $('#hidden-c_id').val('');
        $('#hidden-c_project_id').val('');
        $('#hidden-c_item_id').val('');
        $('#hidden-c_item_exposed_face').val('');
        $('#hidden-c_item_nominal_thickness').val('');
        $('#hidden-c_item_nominal_width').val('');
        $('#hidden-c_item_actual_width').val('');

        $('#default-c_square_footage').val('');
        $('#default-c_linear_footage').val('');
        $('#default-c_board_footage').val('');

        $('#edit-c_square_footage').val('');
        $('#edit-c_linear_footage').val('');
        $('#edit-c_board_footage').val('');

        // Left Box
        $('#edit-c_item_custom_name').val('');
        $('#edit-c_item_mill_setup_fee').val('');
        $('#edit-c_item_finisher_setup_fee').val('');
        $('#edit-c_item_density').val('');
        $('#edit-c_load_weight').val('');
        $('#edit-c_item_customer_notes').val('');
        $('#edit-c_item_mill_notes').val('');

        // Right Box
        $('#edit-c_item_bl_grade').val('');
        $('#edit-c_item_mill_grade').val('');
        $('#edit-c_item_finisher_id').val('');
        $('#edit-c_item_finish').val('');
        $('#edit-c_item_pattern_type').val('');
        $('#edit-c_item_actual_thickness').val('');
        $('#edit-c_item_actual_width').val('');
        $('#edit-c_item_exposed_face').val('');
        $('#edit-c_item_use_id').val('');
        $('#edit-c_item_surface').val('');
        $('#edit-c_item_seasoning_id').val('');

        $('#display-c_pattern_image').attr('src', '');
        $('#remove-custom-pattern-image').val('');
        $('#display-item-c_pattern_image_path').attr('src', '');
        $('#display-item-c_pattern_image_path').hide();
        $('#display-c_pattern_image_path').hide();

        $('#edit-c_item_tally_notes').val('');
        $('#edit-c_tally_type').val('');

        $('#edit-c_item_nominal_thickness').val('');
        $('#edit-c_item_nominal_width').val('')
        $('#tbl_items_c_item_species_id').val('');

        $('#edit-c_item_product_id').val('');
        $('#edit-c_item_variance').val('');

        $('#edit-build-item-form-errors').removeClass('d-block');
        $('#edit-build-item-form-errors').addClass('d-none');
        $('#edit-build-item-form .is-invalid').removeClass('is-invalid');

    });

    // On file input change, show preview
    $('#custom-pattern-image').on('change', function(e) {
        // Get preview image element
        var $preview = $('#display-c_pattern_image');

        // Get file
        var file = e.target.files[0];

        // Check if file is an image
        if (file.type.match('image.*')) {
            // Create file reader
            var reader = new FileReader();

            // Set file reader onload function
            reader.onload = function(e) {
            // Set preview image src to data URL
            $preview.attr('src', e.target.result);

            // Show preview
            $preview.show();
            };

            // Read file as data URL
            reader.readAsDataURL(file);
            $('#display-item-c_pattern_image_path').hide();
        } else {
            // File is not an image, hide preview
            $preview.hide();
            $('#display-item-c_pattern_image_path').show();
        }
    });

    $('#clear-custom-pattern-image').on('click', function() {
        // Get preview image element
        $('#display-c_pattern_image').hide();
        $('#custom-pattern-image').val('');
        $('#remove-custom-pattern-image').val(1);
        $('#display-item-c_pattern_image_path').show();
    });

    $('#edit-c_item_mill_grade').on('change', function(e) {
        const $this = $(this);
        const selectedOption = $this.find('option:selected');
        $('#edit-c_item_bl_grade').val(selectedOption.data('bl_grade'));
    });

    $(`
        #edit-c_square_footage,
        #edit-c_linear_footage,
        #edit-c_item_exposed_face,
        #edit-c_item_nominal_thickness,
        #edit-c_item_nominal_width,
        #edit-c_item_exposed_face,
        #edit-c_cost_per_mbft,
        #edit-c_item_mill_setup_fee,
        #edit-c_item_finisher_setup_fee
    `).on('input', calculateAndUpdateBoardFeet);

    $('#edit-build-item-form').on('submit', function(e) {
        e.preventDefault();

        const $this = $(this);
        const action = e.originalEvent.submitter.value

        // const $form = $this.closest('form');
        const projectId = $('#hidden-c_project_id').val()
        const projectItemId = $('#hidden-c_id').val();

        var formData = new FormData(this); // Create FormData object from the form

        $this.find('input').removeClass('is-invalid');

        if (action === 'update') {

            formData.append("_method", 'PATCH');

            axios.post(`/projects/${projectId}/project-items/${projectItemId}`, formData)
                .then(function (response) {

                    if (response.data.success) {
                        // Success
                        $('#edit-build-item-form-errors').removeClass('alert-danger');
                        $('#edit-build-item-form-errors').addClass('alert-success');
                        $('#edit-build-item-form-errors').removeClass('d-none');
                        $('#edit-build-item-form-errors').addClass('d-block');
                        $('#edit-build-item-form-errors').html(response.data.message);

                        const buildItem = response.data.data;

                        $('#edit-c_item_name').html(buildItem.item.c_item_concat_name);
                        $('#display-c_item_mill_id').html(buildItem.item.c_item_mill_id);

                        updateItemInEditItemsTable(buildItem);
                        toastr.success('Item updated!');

                    } else {
                        // Fail

                        let html = '';
                        Object.keys(response.data.errors).map(error => {
                            html += `<li>${response.data.errors[error]}</li>`;
                            $(`#${error}`).addClass('is-invalid');
                        });

                        $('#edit-build-item-form-errors').html(`<ul class="mb-0">${html}</ul>`);
                        $('#edit-build-item-form-errors').removeClass('alert-success');
                        $('#edit-build-item-form-errors').addClass('alert-danger');
                        $('#edit-build-item-form-errors').removeClass('d-none');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else if (action === 'save-as-new') {

            axios.post(`/project-items/${projectItemId}/save-as-new`, formData)
                .then(function (response) {

                    if (response.data.success) {
                        // Success
                        addItemToEditItemsTable(response.data.data);
                        toastr.success('Item saves as new!');

                    } else {
                        // Fail

                        let html = '';
                        Object.keys(response.data.errors).map(error => {
                            html += `<li>${response.data.errors[error]}</li>`;
                            $(`#${error}`).addClass('is-invalid');
                        });

                        $('#edit-build-item-form-errors').html(`<ul class="mb-0">${html}</ul>`);
                        $('#edit-build-item-form-errors').removeClass('alert-success');
                        $('#edit-build-item-form-errors').addClass('alert-danger');
                        $('#edit-build-item-form-errors').removeClass('d-none');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    });

    // Error Handling
    $(`
        #tbl_project_items_c_square_footage,
        #tbl_project_items_c_linear_footage
    `).on('input', function(e) {
        const $this = $(this);
        if ($this.val() > 0 && $this.val() != '') {
            $('#tbl_project_items_c_square_footage,#tbl_project_items_c_linear_footage').removeClass('is-invalid');
        }
    });

    $(document).on('change', '#item-builder-preview .item-array-input', function(e) {
        if (this.checked) {
            $('#item-builder-preview').removeClass('bg-danger bg-opacity-10');
        }
    });

});

function calculateAndUpdateBoardFeet(e) {
    const $this = $(this);

    // Calculate
    const footInInches = 12;
    const currentFieldId = $this.attr('id');
    const isSquareFootageField = currentFieldId === 'edit-c_square_footage';
    const isLinearFootageField = currentFieldId === 'edit-c_linear_footage';
    const isExposedFaceField = currentFieldId === 'edit-c_item_exposed_face';

    // Allow perioids
    if ((isSquareFootageField || isLinearFootageField) && $this.val().substr(-1) == '\.') {
        return;
    }

    // Get data
    const squareFootage = parseFloat($('#edit-c_square_footage').val());
    const linearFootage = parseFloat($('#edit-c_linear_footage').val());
    const costPerMbft = parseFloat($('#edit-c_cost_per_mbft').val());
    const exposedFace = fractionToDecimal($('#edit-c_item_exposed_face').val(), 4);
    const nominalThickness = fractionToDecimal($('#edit-c_item_nominal_thickness').val(), 4);
    const nominalWidth = fractionToDecimal($('#edit-c_item_nominal_width').val(), 4);
    const millSetupFee = $('#edit-c_item_mill_setup_fee').val() ? parseFloat($('#edit-c_item_mill_setup_fee').val()) : 0;
    const finisherSetupFee = $('#edit-c_item_finisher_setup_fee').val() ? parseFloat($('#edit-c_item_finisher_setup_fee').val()) : 0;

    // Calculate
    const calcSquareFeet = isLinearFootageField ? parseFloat(((linearFootage * exposedFace) / footInInches).toFixed(3)) : squareFootage;
    const calcLinearFeet = isSquareFootageField || isExposedFaceField ? parseFloat(((calcSquareFeet * footInInches) / exposedFace).toFixed(4)) : linearFootage;
    const calcBoardFeet = parseFloat(((calcLinearFeet * nominalWidth * nominalThickness) / footInInches).toFixed(4));
    const pricePerBoardFeet = (costPerMbft / 1000).toFixed(3);
    const pricePerSquareFeet = ((pricePerBoardFeet / calcBoardFeet) * calcSquareFeet).toFixed(3);
    const itemTotalQuoted = ((pricePerSquareFeet * calcSquareFeet) + millSetupFee + finisherSetupFee).toFixed(2);

    // Update Fields
    $('#edit-c_square_footage').val(!isNaN(calcSquareFeet) ? calcSquareFeet : '');
    $('#edit-c_linear_footage').val(!isNaN(calcLinearFeet) ? calcLinearFeet : '');
    $('#edit-c_board_footage').val(!isNaN(calcBoardFeet) ? calcBoardFeet : '');
    $('#display-c_item_total_quoted').val(!isNaN(itemTotalQuoted) ? itemTotalQuoted : '');
}

function updateItemInEditItemsTable(buildItem) {

    html = `
        <tr class="item-builder-row-${buildItem.c_id}">
            <td>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" name="remove[]" value="${buildItem.c_id}">
                </div>
            </td>

            <td>
                <div class="row justify-content-center">
                    <form id="clone-build-item" class="clone-build-item d-inline w-auto p-0 ps-1 p-e1" method="POST" action="${buildItem.action_clone}">
                        <input type="hidden" name="_method" value="POST">
                        <button type="submit" class="btn btn-link p-0" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Clone" data-bs-original-title="Clone">
                            <svg class="" height="20px" width="20px" fill="#0d6efd">
                                <use xlink:href="#content-copy" height="20px" width="20px"></use>
                            </svg>
                        </button>
                    </form>

                    <form class="delete-build-item d-inline w-auto p-0 ps-1 p-e1" method="POST" action="${buildItem.action_delete}">
                        <input type="hidden" name="_method" value="DELETE">
                            <button type="submit" class="btn btn-link p-0" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                <svg class="" height="20px" width="20px" fill="#DC3545">
                                    <use xlink:href="#delete" height="20px" width="20px"></use>
                                </svg>
                        </button>
                    </form>
                </div>
            </td>

            <td>
                <a href="#edit-build-item" class="edit-build-item-toggle text-primary" data-project_id="${buildItem.c_project_id}" data-project_item_id="${buildItem.c_id}">View</a>
            </td>

            <td>${buildItem.c_square_footage || ''}</td>
            <td>${buildItem.c_linear_footage || ''}</td>
            <td>${buildItem.item.c_item_nominal_thickness_fraction || ''}</td>
            <td>${buildItem.item.c_item_nominal_width_fraction || ''}</td>
            <td>${buildItem.item.c_item_actual_thickness_fraction || ''}</td>
            <td>${buildItem.item.c_item_actual_width_fraction || ''}</td>
            <td>${buildItem.item.c_item_exposed_face_fraction || ''}</td>
            <td>${buildItem.item.c_item_species_id || ''}</td>
            <td>${buildItem.item.c_item_bl_grade || ''}</td>
            <td>${buildItem.item.c_item_pattern_type || ''}</td>
            <td>${buildItem.item.c_item_surface || ''}</td>
            <td>${buildItem.item.c_item_finish || ''}</td>
            <td>${buildItem.item.c_item_mill_id || ''}</td>
            <td>${buildItem.item.c_item_finisher_id || ''}</td>

        </tr>
    `;

    return $(`.item-builder-row-${buildItem.c_id}`).replaceWith(html);
}

function addItemToEditItemsTable(buildItem, returnHtml = false) {
    html = `
        <tr>
            <td>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" name="remove[]" value="${buildItem.c_id}">
                </div>
            </td>

            <td>
                <div class="row justify-content-center">
                    <form id="clone-build-item" class="clone-build-item d-inline w-auto p-0 ps-1 p-e1" method="POST" action="${buildItem.action_clone}">
                        <input type="hidden" name="_method" value="POST">
                        <button type="submit" class="btn btn-link p-0" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Clone" data-bs-original-title="Clone">
                            <svg class="" height="20px" width="20px" fill="#0d6efd">
                                <use xlink:href="#content-copy" height="20px" width="20px"></use>
                            </svg>
                        </button>
                    </form>

                    <form class="delete-build-item d-inline w-auto p-0 ps-1 p-e1" method="POST" action="${buildItem.action_delete}">
                        <input type="hidden" name="_method" value="DELETE">
                            <button type="submit" class="btn btn-link p-0" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Remove" data-bs-original-title="Remove">
                                <svg class="" height="20px" width="20px" fill="#DC3545">
                                    <use xlink:href="#delete" height="20px" width="20px"></use>
                                </svg>
                        </button>
                    </form>
                </div>
            </td>

            <td>
                <a href="#edit-build-item" class="edit-build-item-toggle text-primary" data-project_id="${buildItem.c_project_id}" data-project_item_id="${buildItem.c_id}">View</a>
            </td>

            <td>${buildItem.c_square_footage || ''}</td>
            <td>${buildItem.c_linear_footage || ''}</td>
            <td>${buildItem.item.c_item_nominal_thickness_fraction || ''}</td>
            <td>${buildItem.item.c_item_nominal_width_fraction || ''}</td>
            <td>${buildItem.item.c_item_actual_thickness_fraction || ''}</td>
            <td>${buildItem.item.c_item_actual_width_fraction || ''}</td>
            <td>${buildItem.item.c_item_exposed_face_fraction || ''}</td>
            <td>${buildItem.item.c_item_species_id || ''}</td>
            <td>${buildItem.item.c_item_bl_grade || ''}</td>
            <td>${buildItem.item.c_item_pattern_type || ''}</td>
            <td>${buildItem.item.c_item_surface || ''}</td>
            <td>${buildItem.item.c_item_finish || ''}</td>
            <td>${buildItem.item.c_item_mill_id || ''}</td>
            <td>${buildItem.item.c_item_finisher_id || ''}</td>
        </tr>
    `;

    return returnHtml ? html : $('#item-builder').append(html);
}

// Function to calculate the greatest common divisor (GCD)
function gcd(a, b) {
    if (b < 0.0000001) return a;
    return gcd(b, Math.floor(a % b));
}

// Function to convert a decimal to a simplified fraction
function decimalToFraction(fraction) {
    fraction = fraction.toString().replace(/0+$/, ''); // Remove trailing zeros
    var len = fraction.toString().length - 2;
    var denominator = Math.pow(10, len);
    var numerator = fraction * denominator;

    var divisor = gcd(numerator, denominator);
    numerator /= divisor;
    denominator /= divisor;

    var displayWholeNumber = Math.floor(numerator / denominator);
    var displayNumerator = Math.floor(numerator) - (Math.floor(denominator) * Math.floor(numerator / denominator));
    var displayDenominator = Math.floor(denominator);
    var displayFractionNumber = displayNumerator + '/' + displayDenominator;

    return (displayWholeNumber ? displayWholeNumber : '') + (displayNumerator != '0' ? ' ' + displayFractionNumber : '');
}

// Function to convert a fraction to a decimal
function fractionToDecimal(fraction, roundToDecimalPlaces = 4) {
    fraction = fraction.trim();
    var numbers = fraction.split(' ');

    var decimal;

    if (numbers.length > 1) {
        var wholeNumber = parseInt(numbers[0]);
        var fractionSplit = numbers[1].split('/');
        decimal = Math.round(wholeNumber + (parseInt(fractionSplit[0]) / parseInt(fractionSplit[1]))) + Number.EPSILON;
    } else {
        if (numbers[0].includes('/')) {
            var fractionSplit = numbers[0].split('/');
            decimal = parseInt(fractionSplit[0]) / parseInt(fractionSplit[1]);
        } else {
            decimal = Math.round(parseFloat(numbers[0]) + Number.EPSILON);
        }
    }

    return parseFloat(decimal.toFixed(roundToDecimalPlaces));
}
